import { IQuestion } from '../pages/task/types';

import { BMI, HEIGHT, WEIGHT } from '../constants';
import queryClient from '../lib/queryClient';

export const calculateBMI = (
  questionnaire: IQuestion,
  questionnaires: IQuestion[],
  submitAnswer: (question: IQuestion) => void
) => {
  if (!questionnaire) return;

  const { question } = questionnaire;

  if (question !== WEIGHT && question !== HEIGHT) return;

  const weightQuestion = questionnaires.find(
    (questionnaire) => questionnaire.question === WEIGHT
  );
  const heightQuestion = questionnaires.find(
    (questionnaire) => questionnaire.question === HEIGHT
  );
  const bmiQuestion = questionnaires.find(
    (questionnaire) => questionnaire.question === BMI
  );

  if (!weightQuestion?.answer || !heightQuestion?.answer) return;

  const weight = Number(weightQuestion.answer);
  let height = Number(heightQuestion.answer);

  if (Number.isNaN(weight) || Number.isNaN(height) || height <= 0) return;

  height /= 100;

  const bmiValue = Math.round((weight / height ** 2) * 100) / 100;

  if (bmiQuestion) {
    const updatedBmiQuestion = {
      ...bmiQuestion,
      answer: bmiValue.toString(),
    };
    submitAnswer(updatedBmiQuestion);
    queryClient.invalidateQueries({
      queryKey: [`medicalquestionnaires-list`],
    });
  }
};
